import { CatalogPricesRequestType } from '~/shared/api/types/catalog';
import { api } from '~/shared/lib/api';

export const getCatalogPrices = async ({
  productId,
}: CatalogPricesRequestType) => {
  const { data } = await api.get(`/api/v1/catalog/prices/${productId}`);

  return data;
};
